import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './views/Login';
import Dashboard from './views/Dashboard';
import OrderFill from './views/OrderFill';
import OrderPlace from './views/OrderPlace';
import QueryInfo from './views/QueryInfo';
import Recruitment from './views/Recruitment';
import Stores from './views/Stores';
import HealthCertificates from './views/HealthCertificates';
import Blacklist from './views/Blacklist';
import Users from './views/Users';
import Layout from './views/Layout';

import ProtectedRoute from './components/ProtectedRoute';
import { AdminRoute } from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={
              <AdminRoute>
                <Dashboard />
              </AdminRoute>
            } />
            <Route path="order-fill" element={<OrderFill />} />
            <Route path="order-place" element={<OrderPlace />} />
            <Route path="query-info" element={<QueryInfo />} />
            <Route path="recruitment" element={<Recruitment />} />
            <Route path="stores" element={<Stores />} />
            <Route path="health-certificates" element={<HealthCertificates />} />
            <Route path="blacklist" element={<Blacklist />} />
            <Route path="users" element={<Users />} />
          </Route>
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
